import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { GrayButton } from '../oval-button/oval-button';

export const TimerButton = (props) => {
  const { title, icon, timeout = 0, action, disabled = false } = props;
  const [blocked, setBlocked] = useState(false);
  const { t } = useTranslation();

  /**
   * do button action with blocking
   * @returns
   */
  const doAction = () => {
    if (blocked) {
      return;
    }
    if (timeout > 0) {
      setBlocked(true);
    }
    action();
    if (timeout > 0) {
      setTimeout(() => {
        setBlocked(false);
      }, timeout);
    }
  };

  return (
    <GrayButton disabled={disabled} className={blocked ? 'loading' : ''} onClick={doAction}>
      <img src={`/images/${icon}`} alt="" />
      {t(`buttons.${title}`)}
    </GrayButton>
  );
};
